import { Grid, useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { useSelector } from 'modules/react-redux';
import { memo, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { routingService } from 'services/routing';
import { useGetInvitations } from 'shared/data/webApp/v2';
import { useShouldNewOrgPopupNoCompanies } from 'shared/hooks/useShouldNewOrgPopupNoCompanies';

import { Layout } from './layout';
import { PendingInvitations, WhatYouCanDoNow } from './resources/components';
import { useBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { messages } from './resources/messages';

const Page = memo(() => {
    useLayout({ hasHeader: true, hasDrawer: true });
    useBreadcrumbs();

    const startupData = useSelector(selectors.session.getStartupData);
    const companies = useSelector(selectors.company.companiesSelector);
    const someCompanies = companies.length > 0;
    const { data: { items: invitations } = {} } = useGetInvitations();

    const shouldOpenNewOrgPopup = useShouldNewOrgPopupNoCompanies();

    useEffect(() => {
        if (someCompanies) {
            routingService.pushToDefaultPath();
        }
    }, [someCompanies]);

    if (someCompanies) {
        return null;
    }

    return (
        <>
            <Helmet title={messages.title} />

            <Layout>
                <Grid
                    height='100%'
                    alignItems='center'
                    justifyContent='center'
                    alignContent='center'
                    gap={40}
                    gridTemplateColumns='min-content'
                >
                    {!startupData.needsToCompleteSignupWizard && (
                        <PendingInvitations pendingInvitations={invitations} />
                    )}

                    <WhatYouCanDoNow openNewOrgPopopOnMount={!invitations?.length && shouldOpenNewOrgPopup} />
                </Grid>
            </Layout>
        </>
    );
});

Page.displayName = 'Page';

export default pageHocs.withProtected({ Page });
